import { PrispevokVestnikaDeleteApi } from 'vestniky-frontend-ts-axios';
import { ClientResponse } from '../model/types/ClientResponse';
import apiConfiguration from './configuration/apiConfiguration';
import { vestnikyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new PrispevokVestnikaDeleteApi(apiConfiguration(vestnikyPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const deletePrispevokVestnika = async (
  uuid: string,
  options?: { headers?: object },
): Promise<ClientResponse<void>> => {
  const { status } = await client.deletePrispevokVestnika(uuid, options);
  return {
    responseCode: status,
  };
};
